import { put, select, takeEvery } from 'redux-saga/effects';
import { actionTypes as loginAT, getHasAuthenticationLoaded } from 'store/login';
import { actionTypes as loginActionTypes } from 'store/login';

/**
 * Dispatches LOGIN_STATUS_KNOWN as soon as Migros and Spring Login status is known
 * Note: this does not necessarily mean that we are logged in
 */
function* authenticationStatusIsKnown() {
	const hasAuthenticationLoaded = yield select(getHasAuthenticationLoaded);
	if (hasAuthenticationLoaded) {
		yield put({
			type: loginAT.LOGIN_STATUS_KNOWN,
		});
	}
}

function* loginSagas() {
	yield takeEvery([loginActionTypes.CHANGE_MIGROS_LOGIN_STATUS], authenticationStatusIsKnown);
}

export default loginSagas;
